<!--
 * @Author: DQL
 * @Date: 2020-03-30 19:02:49
 * @LastEditors: DQL
 * @LastEditTime: 2022-05-23 14:57:15
 * @Description: file content
 -->
<template>
  <hm-layout
    ref="layout"
    :is-collapse-menu="config.isCollapseMenu"
    :has-menu-search="config.hasMenuSearch"
    :open-navtab-limit="config.openNavtabLimit"
    :app-logo="appLogo"
    :app-name="'鸿蒙OA'"
    :copyright="config.copyright"
    :package-json="packageJson"
    :header-right-cog-sort="['user', 'changePwd', 'logout']"
    @logout="handleLogout"
    @changeSubject="handleChangeSubject"
    @openMenu="handleOpenMenu"
  >
    <template
      v-slot:changePwd
    >
      <div
        class="c-fheader__nav-item u-pointer"
        title="修改密码"
        @click="handleDialog('changePassword')"
      >
        <i class="kestrel-icon ki-key" />
      </div>
    </template>

    <!-- 修改密码窗口 -->
    <change-password-dialog
      v-if="showDialogName == 'changePassword'"
      @closeDialog="handleDialog"
    />
  </hm-layout>
</template>

<script>
import config from '@/config.js';
import packageJson from '../package.json';
import { logoutSys, changeSubject } from '@/features/feature.common.service';
import ChangePasswordDialog from '@/features/headerBar/changePasswordDialog.vue';

export default {
  name: 'Layout',
  components: { ChangePasswordDialog },
  data () {
    return {
      appLogo: process.env.BASE_URL + 'assets/logo.png',
      config: config,
      packageJson: packageJson,
      showDialogName: null,
      env: process.env.NODE_ENV
    };
  },
  methods: {
    /**
     * @description: 退出系统
     * @param {*}
     * @return {*}
     */
    handleLogout () {
      const _this = this;
      logoutSys().then(rsp => {
        _this.$HMCookies.unset(config.localTokenName); // 清除cookie
        _this.$HMStoreService.removeUserinfo(); // 清除用户信息
        _this.$HMStoreService.resetNavTab(); // 清除导航页签navtab
        _this.$router.push('/login'); // 路由跳转登录页面
      });
    },
    /**
     * @description: 切换身份
     * @param {String} _selectedCapacity 选择的身份uuid
     * @return {*}
     */
    handleChangeSubject (_selectedCapacity) {
      this.$confirm('确认切换身份吗？切换身份，系统将重新载入！', '提示', { type: 'warning' })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: '切换身份中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          changeSubject(_selectedCapacity)
            .then(rsp => {
              /* 更新token Start */
              const token = rsp.headers[config.serverHeaderTokenName];
              this.$HMCookies.set(config.localTokenName, token);
              /* 更新token End */
              loading.close();
              this.$refs.layout.closeSwitchSubjectDialog();
              document.getElementById('preloading').style.display = 'table';
              const reloadHref = window.location.href.split(window.location.hash)[0];
              window.location.href = reloadHref;
            })
            .catch(err => {
              console.error('切换身份失败', err);
              loading.close();
            });
        });
    },
    handleOpenMenu (_menu) {
      console.log('点击菜单', _menu);
    },
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name) {
      this.showDialogName = _name;
    },
    handleClickOpenExample () {
      window.open(location.origin + location.pathname + '#/examples');
    }
  },
  mounted () {
    console.log(this.$HMThemeService);
  },
  created () {
    document.title = '鸿蒙OA';
  }
};
</script>
